import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { t } from 'i18next';
import { Beforeunload } from 'react-beforeunload';
import FormProgressBar from '../ReactComponent/FormProgressBar';
import {
  H1, H3, P, PLight,
} from '../../theme/typography';
import Tooltip from '../../lib/ui/form_elements/Tooltip';
import { digitOnly } from '../../utils/mask';
import {
  PrimaryButton,
  SecondaryButton,
  ButtonGroup,
  FormContainer,
  SuccessMessageBox,
  DivRender,
} from './css';
import {
  Step1, Step2, Step3, Step4,
} from './steps';
import { Divisions } from '../../utils/enums';
import { scrollToTop, runningOnBrowser } from '../../utils/func';
import { endpoints } from '../../utils/constants';
import ClaimSubmission_Icon from '../../assets/icons/ClaimSubmission_Icon.png';

class SubmitClaimForm extends PureComponent {
  constructor(props) {
    super(props);
    const { fields } = props;
    this.steps = [
      fields.step1Title.value,
      fields.step2Title.value,
      fields.step3Title.value,
      fields.step4Title.value];
    this.state = {
      currentStep: 0,
      apiResponse: '',
      totalClaimValue: 0,
    };
  }

  updateTotalClaimValue = (value) => {
    this.setState({ totalClaimValue: value });
  };

  nextStep = (e) => {
    e.preventDefault();
    if (this.props.valid) {
      this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
        setTimeout(() => scrollToTop(), 200);
      });
    }
  };

  prevStep = (e) => {
    e.preventDefault();
    scrollToTop();
    this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }));
  };

  editStepOne = () => {
    scrollToTop();
    this.setState({ currentStep: 0 });
  };

  editStepTwo = () => {
    scrollToTop();
    this.setState({ currentStep: 1 });
  };

  editStepThree = () => {
    scrollToTop();
    this.setState({ currentStep: 2 });
  };

  checkUploadFiles = (uploadedFilesArr) => {
    const uploadedFiles = [];
    uploadedFilesArr.map((fileValues) => {
      if (fileValues) {
        uploadedFiles.push({ fileName: fileValues.name, fileDataAsBase64: fileValues.file });
      }

      return undefined;
    });
    return uploadedFiles;
  };

  checkUploadFilesItems = (uploadedFilesArr) => {
    const uploadedFiles = [];
    if (uploadedFilesArr) {
      Object.values(uploadedFilesArr).map((fileValues) => {
        if (fileValues) {
          uploadedFiles.push({ fileName: fileValues.name, fileDataAsBase64: fileValues.file });
        }

        return undefined;
      });
    }

    return uploadedFiles;
  };

  handleFreightSubmit = () => {
    const {
      formData: {
        ReferenceNumber,
        ClaimantName,
        ClaimantAddress,
        ContactName,
        PhoneNumber,
        Extension,
        EmailAddress,
        FreightBill,
        ShipperName,
        ShipperTelephoneNumber,
        ShipperExtension,
        ConsigneeName,
        ConsigneeTelephoneNumber,
        ConsigneeExtension,
        TypeOfClaim,
        AdditionalDamageInfo,
        DamageExplanation,
        QualityControl,
        Currency,
        PartsInformation,
        ProBillNumber,
        PaidFreightBill,
        ProofOfDelivery,
        CopyOfClaimantsCostInvoice,
        CopyOfRepairBill,
        SupportingDocumentation,
        PicturesOfAnyDamage,
        PicturesOfTrailerOrContainer,
        ClaimForm,
        PackingSlip,
        PartsInvoice,
      }, divisionCode,
    } = this.props;
    let division = '';
    switch (divisionCode) {
      case Divisions.Freight.code: division = Divisions.Freight.name; break;
      case Divisions.Sameday.code: division = Divisions.Sameday.name; break;
      default: division = Divisions.Freight.name; break;
    }

    const items = PartsInformation.map((each) => {
      const { PartDescription, ClaimAmount, PartFileUpload } = each;
      return {
        amount: parseFloat(ClaimAmount),
        description: PartDescription,
        file: this.checkUploadFilesItems(PartFileUpload),
      };
    });

    const AttachmentFiles = [
      ProBillNumber,
      PaidFreightBill,
      ProofOfDelivery,
      CopyOfClaimantsCostInvoice,
      CopyOfRepairBill,
      SupportingDocumentation,
      PicturesOfAnyDamage,
      PicturesOfTrailerOrContainer,
      ClaimForm,
      PackingSlip,
      PartsInvoice,
    ];

    const formValueToAPI = {
      accountNumber: ReferenceNumber,
      companyName: ClaimantName,
      address: ClaimantAddress,
      contactName: ContactName,
      contactPhoneNumber: digitOnly(PhoneNumber),
      contactPhoneNumberExt: Extension,
      contactEmail: EmailAddress,
      proBillNumber: FreightBill,
      shipperName: ShipperName,
      shipperPhoneNumber: digitOnly(ShipperTelephoneNumber),
      shipperPhoneNumberExt: ShipperExtension,
      consigneeName: ConsigneeName,
      consigneePhoneNumber: digitOnly(ConsigneeTelephoneNumber),
      consigneePhoneNumberExt: ConsigneeExtension,
      claimType: TypeOfClaim,
      isDamageRepairable: AdditionalDamageInfo === 'Yes',
      claimExplanation: DamageExplanation,
      isTestingCompleted: QualityControl === 'Yes',
      items: [...items],
      uploadFiles: this.checkUploadFiles(AttachmentFiles),
      currencyCode: Currency,
    };
    axios.post(`${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${endpoints.shipping.submitClaims}/${division}`, formValueToAPI).then((res) => {
      if (res.status === 200) {
        this.setState({ apiResponse: 'success' });
      }
    });
  };

  handleSubmit = () => {
    const {
      formData: {
        DealerName,
        DealerCode,
        DealerCompleteAddress,
        CompanyName,
        ContactName,
        PhoneNumber,
        EmailAddress,
        FreightBill,
        TypeOfClaim,
        ClaimValue,
        Currency,
        ContactedCustomerService,
        DateContactCustomerService,
        DescriptionOfTheClaim,
        PartsInformation,
        ProBillNumber,
        PaidFreightBill,
        ProofOfDelivery,
        CopyOfClaimantsCostInvoice,
        CopyOfRepairBill,
        SupportingDocumentation,
        PicturesOfAnyDamage,
        PicturesOfTrailerOrContainer,
        ClaimForm,
        PackingSlip,
        PartsInvoice,
      },
    } = this.props;

    const parts = PartsInformation.map((each) => {
      const {
        PartNumber, PartDescription, PartFileUpload, PartDeliveryDate,
      } = each;

      return {
        partNumber: PartNumber,
        description: PartDescription,
        file: this.checkUploadFilesItems(PartFileUpload),
        deliveryDate: PartDeliveryDate,
      };
    });

    const AttachmentFiles = [
      ProBillNumber,
      PaidFreightBill,
      ProofOfDelivery,
      CopyOfClaimantsCostInvoice,
      CopyOfRepairBill,
      SupportingDocumentation,
      PicturesOfAnyDamage,
      PicturesOfTrailerOrContainer,
      ClaimForm,
      PackingSlip,
      PartsInvoice,
    ];

    const formValueToAPI = {
      dealerName: DealerName,
      dealerCode: DealerCode,
      dealerAddress: DealerCompleteAddress,
      companyName: CompanyName,
      contactName: ContactName,
      contactPhoneNumber: digitOnly(PhoneNumber),
      contactEmail: EmailAddress,
      proBillNumber: FreightBill,
      claimType: TypeOfClaim,
      claimAmount: parseFloat(ClaimValue),
      claimAmountCurrencyCode: Currency,
      hasContactedCustomerService: ContactedCustomerService === 'Yes',
      contactedOnDate: DateContactCustomerService,
      claimDescription: DescriptionOfTheClaim,
      parts: [
        ...parts,
      ],
      uploadFiles: this.checkUploadFiles(AttachmentFiles),
    };
    axios.post(`${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${endpoints.shipping.submitClaims}/dedicated`, formValueToAPI).then((res) => {
      if (res.status === 200) {
        this.setState({ apiResponse: 'success' });
      }
    });
  };

  render() {
    const {
      formData, valid, handleSubmit, submitSucceeded, fields,
    } = this.props;
    const isFreight = fields.freightForm && fields.freightForm.value;
    let onlyOnlineForm = true;
    if (runningOnBrowser()) {
      if (window.location.href.includes('dedicated')) {
        onlyOnlineForm = false;
      }
    }

    return (
      <div>
        <Beforeunload onBeforeunload={() => "You'll lose your data!"} />
        <FormProgressBar current={this.state.currentStep} steps={this.steps} />
        <FormContainer>
          {submitSucceeded && this.state.apiResponse === 'success' ? (
            <SuccessMessageBox>
              <img className="success-image" src={ClaimSubmission_Icon} alt="Claim submission icon" />
              <H1 className="center">{t('ClaimSuccessHeader')}</H1>
              <P className="center">{t('ClaimSuccessText')}</P>
              <ButtonGroup className="center">
                <SecondaryButton
                  onClick={() => {
                    window.location.href = fields.manageClaimsLink.value.href;
                  }}
                  className="active min-width"
                >
                  <span className="icon-left" />
                  {fields.manageClaimsLink.value.text}
                </SecondaryButton>
              </ButtonGroup>
            </SuccessMessageBox>
          ) : (

            <form onSubmit={isFreight ? handleSubmit(this.handleFreightSubmit) : handleSubmit(this.handleSubmit)}>
              <Step1
                step={this.state.currentStep}
                fields={this.props.fields}
                isFreight={isFreight}
              />
              <Step2
                formData={formData}
                step={this.state.currentStep}
                fields={this.props.fields}
                isFreight={isFreight}
                updateTotalClaimValue={this.updateTotalClaimValue}
              />
              <Step3
                formData={formData}
                step={this.state.currentStep}
                fields={this.props.fields}
                isFreight={isFreight}
              />
              <Step4
                formData={formData}
                step={this.state.currentStep}
                editStepOne={this.editStepOne}
                editStepTwo={this.editStepTwo}
                editStepThree={this.editStepThree}
                fields={this.props.fields}
                isFreight={isFreight}
                totalClaimValue={this.state.totalClaimValue}
              />
              {this.state.currentStep === 3 && valid ? (
                <ButtonGroup>
                  <PrimaryButton type="submit" className="submit">
                    <span className="icon" />
                    {t('Submit')}
                  </PrimaryButton>
                </ButtonGroup>
              ) : (
                <ButtonGroup>
                  <SecondaryButton
                    type="button"
                    onClick={this.prevStep}
                    className={`${valid ? 'active' : ''} ${this.state.currentStep === 0 ? 'hidden' : ''}`}
                  >
                    <span className="icon-left" />
                    {t('Back')}
                  </SecondaryButton>
                  <PrimaryButton type="button" onClick={this.nextStep} className={`${valid ? 'active' : ''}`}>
                    <span className="icon" />
                    {t('Next')}
                  </PrimaryButton>
                </ButtonGroup>
              )}
              {(this.state.currentStep === 1 && onlyOnlineForm) ? (
                <>
                  <DivRender style={{ marginTop: '-30px' }}>
                    <H3>{t('MaximumLiabilityClaim')}</H3>
                    <Tooltip message={t('TipDamageClaim')} />
                  </DivRender>
                  <PLight style={{ marginTop: '8px', marginBottom: '20px' }}>
                    <small>{t('DetailedDescriptionOfClaimMaximumLiability')}</small>
                  </PLight>
                </>
              ) : (
                <PLight />
              )}
            </form>
          )}
        </FormContainer>
      </div>
    );
  }
}

SubmitClaimForm.propTypes = {
  fields: PropTypes.object,
  valid: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  formData: PropTypes.object,
  divisionCode: PropTypes.string,
};

SubmitClaimForm = reduxForm({
  form: 'SubmitClaimForm', // a unique identifier for this form
  initialValues: {
    PartsInformation: [{ PartDescription: '', PartNumber: '' }],
    TotalClaimValue: '0',
  },
})(SubmitClaimForm);

const mstp = (state) => ({
  formData: getFormValues('SubmitClaimForm')(state),
  divisionCode: state.profile.divisionCode,
});

export default connect(mstp)(SubmitClaimForm);
